import { getParameter } from '../core'

$.fn.SettingsPanel = function(options) {
  let self = this
  const settings = $.extend({
    panelSelector: '#settings-panel',
    labelOpen: gourmetsauvage_params.SETTINGS_OPEN,
    labelClose: gourmetsauvage_params.SETTINGS_CLOSE,
    closeOnEscape: true,
    closeOnClickOutside: true,
    grid: undefined,
  }, options)

  self.$panel = $(settings.panelSelector)

  const loadSettingsFromStorage = function() {
    if ('localStorage' in window) {
      const savedStockDisplay = localStorage.getItem('product-grid-stock-display')
      const savedDisplayType = localStorage.getItem('product-grid-display-type')
      
      if (savedStockDisplay) {
        self.$panel.find(`input[name="stock-display"][value="${savedStockDisplay}"]`).prop('checked', true)
      }
      
      if (savedDisplayType) {
        self.$panel.find(`input[name="display-type"][value="${savedDisplayType}"]`).prop('checked', true)
      }
    }
  }

  const saveSettingsToStorage = function(stockDisplay, displayType) {
    if ('localStorage' in window) {
      localStorage.setItem('product-grid-stock-display', stockDisplay)
      localStorage.setItem('product-grid-display-type', displayType)
    }
  }

  const updateGridModifiers = function(animate = false) {
    if (!settings.grid) return

    const stockDisplay = self.$panel.find('input[name="stock-display"]:checked').val() || 'show'
    const displayType = self.$panel.find('input[name="display-type"]:checked').val() || 'grid'
    
    saveSettingsToStorage(stockDisplay, displayType)

    if (animate) {
      settings.grid.addClass('--sorting')
      setTimeout(function() {
        settings.grid.removeClass('product-list--stock-show product-list--stock-hide product-list--display-grid product-list--display-list')
        settings.grid.addClass(`product-list--stock-${stockDisplay} product-list--display-${displayType}`)
        setTimeout(function() {
          settings.grid.removeClass('--sorting')
        }, 50)
      }, 300)
    } else {
      settings.grid.removeClass('product-list--stock-show product-list--stock-hide product-list--display-grid product-list--display-list')
      settings.grid.addClass(`product-list--stock-${stockDisplay} product-list--display-${displayType}`)
    }
  }

  loadSettingsFromStorage()
  updateGridModifiers()

  self.$panel.on('change', 'input[name="stock-display"], input[name="display-type"]', function() {
    updateGridModifiers(true)
  })

  return this.each(function() {
    const $trigger = $(this)
    const $panel = $(settings.panelSelector)

    const togglePanel = function(forceClose = false) {
      const isExpanded = $trigger.attr('aria-expanded') === 'true'
      const newState = forceClose ? false : !isExpanded
      $trigger.attr('aria-expanded', newState)
      $panel.attr('aria-hidden', !newState)
      const label = newState ? settings.labelClose : settings.labelOpen
      $trigger.attr('aria-label', label)
      return newState
    }

    $trigger.on('click.settingsPanel', function(e) {
      e.stopPropagation()
      togglePanel()
    })

    if (settings.closeOnClickOutside) {
      $(document).on('click.settingsPanel', function(e) {
        if (!$panel.is(e.target) &&
        $panel.has(e.target).length === 0 &&
        !$trigger.is(e.target) &&
        $trigger.has(e.target).length === 0) {
          if ($trigger.attr('aria-expanded') === 'true') {
            togglePanel(true)
          }
        }
      })
    }

    if (settings.closeOnEscape) {
      $(document).on('keydown.settingsPanel', function(e) {
        if (e.key === 'Escape' && $trigger.attr('aria-expanded') === 'true') {
          togglePanel(true)
          $trigger.focus()
        }
      })
    }

    // Méthodes publiques
    $trigger.data('settingsPanel', {
      open: function() {
        if ($trigger.attr('aria-expanded') === 'false') {
          togglePanel()
        }
      },
      close: function() {
        togglePanel(true)
      },
      toggle: function() {
        togglePanel()
      },
      destroy: function() {
        $(document).off('.settingsPanel')
        $trigger.off('.settingsPanel')
        $trigger.removeData('settingsPanel')
      }
    })
  })
}

$.fn.ProductGrid = function() {
	let self = this
	self.sorting = self.closest('.shop').find('.js-product-sorting')
	self.grid = self
  self.quick_load = false

	self.sorting.each(function() {
		let $select = $(this).Select()
	})

	self.sorting.change(function(){
    if (!self.quick_load) {
      self.grid.addClass('--sorting')
    }
		setTimeout(() => {
			self.grid.removeClass('sort--default sort--date sort--price-asc sort--price-desc sort--best-selling')
			self.grid.addClass('sort--' + self.sorting.val())
			self.grid.removeClass('--sorting')
		}, self.quick_load ? 0 : 500)
	})

  self.check_anchor_sorting = function() {
    let initialOrder = getParameter('ordre')
    if (initialOrder) {
      self.quick_load = true
      if (initialOrder === 'meilleurs-vendeurs') {
        self.sorting.Select().setValue('best-selling')
      } else if (initialOrder === 'en-vedette') {
        self.sorting.Select().setValue('default')
      } else if (initialOrder === 'nouveau') {
        self.sorting.Select().setValue('date')
      } else if (initialOrder === 'prix-croissant') {
        self.sorting.Select().setValue('price-asc')
      } else if (initialOrder === 'prix-decroissant') {
        self.sorting.Select().setValue('price-desc')
      } else {
        let parts = initialOrder.split('-'),
        allIntegers = parts.every(function(part) {
          return /^\d+$/.test(part)
        })
        if (allIntegers) {
          parts.forEach(function(productID) {
            $('.product-list .type-product.post-' + productID).each(function() {
              $(this).prependTo($('.product-list'))
            })
          })
        }
      }
      self.quick_load = false
    }
  }

  self.initialize_settings = function() {
    $('.settings-trigger').each(function() {
      $(this).SettingsPanel({
        panelSelector: '#settings-panel',
        grid: self,
      })
    })
  }

	return function(){
    self.check_anchor_sorting()
    self.initialize_settings(self)
		return self
	}()
}
